import axios from 'axios'
import requesturl from '../requesturl'
import auth from "../auth";
import cookiemanager from "../managers/cookiemanager";

export default {

    async reserveMacs(macReservationDto, response) {

        let headers = {
            'Authorization': window.$cookies.get("token"),
            'Content-Type': 'application/json'
        };
        
        await axios({
            method: 'post',
            url: requesturl() + '/api/latest/reserve',
            headers: headers,
            data: JSON.stringify(macReservationDto)
        }).then(res => {
            cookiemanager.updateCookies(res.headers);
            let requestResponse = {
                data: res.data,
                status: res.status
            };
            response(requestResponse);
        }).catch(error => {
            if (error.response && error.response.status === 401) {
                auth.logout();
                window.$router.push('login');
            }

            if (error.response && error.response.status === 400) {
                let requestResponse = {
                    data: error.response.data,
                    status: error.response.status
                };
                response(requestResponse);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/interfaces/reservationinterface.js